import { render, staticRenderFns } from "./labelList.vue?vue&type=template&id=4af04c98&"
import script from "./labelList.vue?vue&type=script&lang=ts&"
export * from "./labelList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports